import SetPin from './SetPin.jsx';

export default SetPin;